import {type CreatorBrandSafetyVettingStatus} from '@/types/creatorBrandSafetyVetting';
import {VettableCreator} from '@/types/vettableCreatorsResponse';
import api from '../index';

type BatchCreateSuccess = {
  profile_id: string;
  vetting_id: string;
};

type BatchCreateFailures = {
  not_found?: string[];
  error?: string[];
};

export type BatchCreateResponse = {
  success: BatchCreateSuccess[];
  failures: BatchCreateFailures;
};

type VettingUpdaterArgs = {
  status: {
    vettingId: string;
    status: CreatorBrandSafetyVettingStatus;
  };
  create: {
    creator: VettableCreator;
    brandId: string;
    type: string;
  };
  batchCreate: {
    profileIds: string[];
    brandId: string;
  };
  regenerate: {
    vettingId: string;
  };
  tracking: {
    vettingId: string;
    tracking: boolean;
  };
};

const vettingUpdaters = {
  status: async ({vettingId, status}: VettingUpdaterArgs['status']) => {
    return api.put(
      `/creator_brand_safety_vettings/${vettingId}/update_decision`,
      {status}
    );
  },
  batchCreate: async ({
    profileIds,
    brandId,
  }: VettingUpdaterArgs['batchCreate']): Promise<BatchCreateResponse> => {
    return api.post(
      `/creator_brand_safety_vettings/batch_create`,
      {profile_ids: profileIds},
      {params: {brand_id: brandId}}
    ) as unknown as Promise<BatchCreateResponse>;
  },
  create: async ({creator, brandId, type}: VettingUpdaterArgs['create']) => {
    return api.post(
      `/creator_brand_safety_vettings`,
      {invite_only: creator.inviteOnly, creator, type},
      {
        params: {brand_id: brandId},
      }
    );
  },
  regenerate: async ({vettingId}: VettingUpdaterArgs['regenerate']) => {
    return api.post(
      `/creator_brand_safety_vettings/${vettingId}/regenerate_report`
    );
  },
  tracking: async ({vettingId, tracking}: VettingUpdaterArgs['tracking']) => {
    return api.put(
      `/creator_brand_safety_vettings/${vettingId}/update_tracking`,
      {tracking}
    );
  },
};

export default vettingUpdaters;
